export default __webpack_public_path__ + "static/Primary_Endpoint_Chart-SM@2x-ce327ae6ac692e5a8e9d2aa75d824090.png";